// extracted by mini-css-extract-plugin
module.exports = {"button":"action-typeform_button__4Xs8R primary_button__P3_aI core_block__brm6K core_core__W0MVV primary_medium__2W3I9 core_medium__mFxK4"};